// import React, { useState, useEffect } from "react";
// import SelectField from "../../../../ResuableCompoment/SelectField";
// import useApi from "../../../../CustomHooks/useApi";

// const NetworkRole = ({ roleSelected, initialRole, initialIds }) => {
//     console.log("intinialids", initialIds);
//     console.log("intinrole", initialRole);
//     const [isDisabled, setIsDisabled] = useState(false);
//     const [selectedRole, setSelectedRole] = useState("");
//     const [roleOptions, setRoleOptions] = useState([]);
//     const [selectedIds, setSelectedIds] = useState({
//         asmId: "",
//         masterDistributorId: "",
//         distributorId: "",
//     });
//     const [isSkipped, setIsSkipped] = useState(false);
//     useEffect(() => {
//         if (initialRole != undefined) {
//             setSelectedRole(initialRole);
//             setIsDisabled(true);
//         }
//         if (initialIds != undefined) {
//             setSelectedIds(initialIds);
//             setIsDisabled(true);
//         }
//     }, [initialRole, initialIds]);
//     const roleOption = [
//         { value: "MASTER_DISTRIBUTOR", label: "Master Distributor" },
//         { value: "DISTRIBUTOR", label: "Distributor" },
//         { value: "MERCHANT", label: "Merchant" },
//         { value: "INDEPENDENT_MERCHANT", label: "Independent Merchant" },
//     ];

//     const { callApi: roleapicall } = useApi(
//         "/staff/onboard/get/roles",
//         "GET"
//     );

//     const handleRoleChange = async (e) => {
//         const selectedValue = e.target.value;
//         setSelectedRole(selectedValue);
//         setIsSkipped(false);

//         const resetIds = {
//             asmId: "",
//             masterDistributorId: "",
//             distributorId: "",
//         };
//         setSelectedIds(resetIds);

//         roleSelected({
//             role: selectedValue,
//             selectedIds: resetIds,
//         });

//         let roleType = "";

//         switch (selectedValue) {
//             case "MASTER_DISTRIBUTOR":
//                 roleType = "ASM";
//                 break;

//             case "DISTRIBUTOR":
//                 roleType = "MASTER_DISTRIBUTOR";
//                 break;

//             case "MERCHANT":
//                 roleType = "DISTRIBUTOR";
//                 break;

//             case "INDEPENDENT_MERCHANT":   // ✅ NEW
//                 roleType = "ASM";
//                 break;

//             default:
//                 roleType = "";
//         }

//         if (roleType) {
//             const response = await roleapicall(null, `role_type=${roleType}`);
//             if (response) {
//                 const formattedOptions = response.map((item) => ({
//                     value: item.userId,
//                     label: `${item.meta.fullName} (${item.mobile_number})`,
//                 }));
//                 setRoleOptions(formattedOptions);
//             } else {
//                 setRoleOptions([]);
//             }
//         } else {
//             setRoleOptions([]);
//         }
//     };

//     const handleIdChange = (e) => {
//         const { name, value } = e.target;

//         const updatedIds = {
//             ...selectedIds,
//             [name === "asm"
//                 ? "asmId"
//                 : name === "MASTER_DISTRIBUTOR"
//                     ? "masterDistributorId"
//                     : "distributorId"]: value,
//         };

//         setSelectedIds(updatedIds);

//         roleSelected({
//             role: selectedRole,
//             selectedIds: updatedIds,
//         });
//     };

//     const handleSkip = async () => {
//         setIsSkipped(true);
//         const response = await roleapicall(null, `role_type=ASM`);
//         if (response) {
//             const formattedOptions = response.map((item) => ({
//                 value: item.userId,
//                 label: `${item.meta.fullName} (${item.mobile_number})`,
//             }));
//             setRoleOptions(formattedOptions);
//         } else {
//             setRoleOptions([]);
//         }
//     };

//     return (
//         <div className="w-full bg-white p-4 rounded-lg shadow-2xl mb-4">
//             <SelectField
//                 label="Select Role"
//                 name="role"
//                 value={selectedRole}
//                 onChange={handleRoleChange}
//                 options={roleOption}
//                 required={true}
//                 disabled={isDisabled}
//                 className={`${isDisabled ? "bg-gray-500 text-gray-500 cursor-not-allowed  pointer-events-none" : ""
//                     }`}
//             />

//             {selectedRole === "INDEPENDENT_MERCHANT" && roleOptions.length > 0 && (
//                 <SelectField
//                     label="Select ASM"
//                     name="asm"
//                     value={selectedIds.asmId}
//                     onChange={handleIdChange}
//                     options={roleOptions}
//                     required={true}
//                 />
//             )}

//             {selectedRole === "MASTER_DISTRIBUTOR" && roleOptions.length > 0 && (
//                 <SelectField
//                     label="Select ASM"
//                     name="asm"
//                     value={selectedIds.asmId}
//                     onChange={handleIdChange}
//                     options={roleOptions}
//                     required={true}
//                 />
//             )}

//             {selectedRole === "DISTRIBUTOR" && !isSkipped && roleOptions.length > 0 && (
//                 <>
//                     <SelectField
//                         label="Select MASTER_DISTRIBUTOR"
//                         name="MASTER_DISTRIBUTOR"
//                         value={selectedIds.masterDistributorId}
//                         onChange={handleIdChange}
//                         options={roleOptions}
//                         required={true}
//                     />
//                     <button
//                         type="button"
//                         className="mt-2 px-4 py-2 bg-gray-300 rounded"
//                         onClick={handleSkip}
//                     >
//                         Skip
//                     </button>
//                 </>
//             )}

//             {selectedRole === "DISTRIBUTOR" && isSkipped && roleOptions.length > 0 && (
//                 <SelectField
//                     label="Select ASM"
//                     name="asm"
//                     value={selectedIds.asmId}
//                     onChange={handleIdChange}
//                     options={roleOptions}
//                     required={true}
//                 />
//             )}

//             {selectedRole === "MERCHANT" && roleOptions.length > 0 && (
//                 <SelectField
//                     label="Select DISTRIBUTOR"
//                     name="DISTRIBUTOR"
//                     value={selectedIds.distributorId}
//                     onChange={handleIdChange}
//                     options={roleOptions}
//                     required={true}
//                 />
//             )}
//         </div>
//     );
// };

// export default NetworkRole;




import React, { useState, useEffect, useRef } from "react";
import SelectField from "../../../../ResuableCompoment/SelectField";
import useApi from "../../../../CustomHooks/useApi";

// --- CUSTOM SEARCHABLE DROPDOWN COMPONENT ---
const SearchableSelect = ({ label, name, value, onChange, options, required, disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const wrapperRef = useRef(null);

    // Find the currently selected option to display its label
    const selectedOption = options.find((opt) => opt.value === value);

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (val) => {
        // Mimic the standard event object so your existing handleIdChange works perfectly
        onChange({ target: { name, value: val } });
        setIsOpen(false);
        setSearchTerm("");
    };

    // Filter options based on user search
    const filteredOptions = options.filter((opt) =>
        opt.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="relative mb-4 w-full" ref={wrapperRef}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <div
                className={`w-full border border-gray-300 rounded-full p-2 bg-white flex justify-between items-center ${
                    disabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : "cursor-pointer"
                }`}
                onClick={() => !disabled && setIsOpen(!isOpen)}
            >
                <span className={`truncate ${!selectedOption ? "text-gray-400" : "text-gray-900"}`}>
                    {selectedOption ? selectedOption.label : "Select an option"}
                </span>
                <svg
                    className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </div>

            {isOpen && !disabled && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                    <div className="p-2 border-b border-gray-200">
                        <input
                            type="text"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0A2A4F]"
                            placeholder="Search by name or number..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()} // Prevent input click from closing dropdown
                            autoFocus
                        />
                    </div>
                    <ul className="max-h-60 overflow-y-auto">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((opt) => (
                                <li
                                    key={opt.value}
                                    className={`p-2 cursor-pointer transition-colors ${
                                        opt.value === value
                                            ? "bg-[#0A2A4F] text-white"
                                            : "text-gray-900 hover:bg-[#F0F6FF]"
                                    }`}
                                    onClick={() => handleSelect(opt.value)}
                                >
                                    {opt.label}
                                </li>
                            ))
                        ) : (
                            <li className="p-3 text-gray-500 text-center text-sm">No options found</li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};
// --------------------------------------------

const NetworkRole = ({ roleSelected, initialRole, initialIds }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [selectedRole, setSelectedRole] = useState("");
    const [roleOptions, setRoleOptions] = useState([]);
    const [selectedIds, setSelectedIds] = useState({
        asmId: "",
        masterDistributorId: "",
        distributorId: "",
    });
    const [isSkipped, setIsSkipped] = useState(false);

    useEffect(() => {
        if (initialRole != undefined) {
            setSelectedRole(initialRole);
            setIsDisabled(true);
        }
        if (initialIds != undefined) {
            setSelectedIds(initialIds);
            setIsDisabled(true);
        }
    }, [initialRole, initialIds]);

    const roleOption = [
        { value: "MASTER_DISTRIBUTOR", label: "Master Distributor" },
        { value: "DISTRIBUTOR", label: "Distributor" },
        { value: "MERCHANT", label: "Merchant" },
        { value: "INDEPENDENT_MERCHANT", label: "Independent Merchant" },
    ];

    const { callApi: roleapicall } = useApi(
        "/staff/onboard/get/roles",
        "GET"
    );

    const handleRoleChange = async (e) => {
        const selectedValue = e.target.value;
        setSelectedRole(selectedValue);
        setIsSkipped(false);

        const resetIds = {
            asmId: "",
            masterDistributorId: "",
            distributorId: "",
        };
        setSelectedIds(resetIds);

        roleSelected({
            role: selectedValue,
            selectedIds: resetIds,
        });

        let roleType = "";

        switch (selectedValue) {
            case "MASTER_DISTRIBUTOR":
                roleType = "ASM";
                break;
            case "DISTRIBUTOR":
                roleType = "MASTER_DISTRIBUTOR";
                break;
            case "MERCHANT":
                roleType = "DISTRIBUTOR";
                break;
            case "INDEPENDENT_MERCHANT": 
                roleType = "ASM";
                break;
            default:
                roleType = "";
        }

        if (roleType) {
            const response = await roleapicall(null, `role_type=${roleType}`);
            if (response) {
                const formattedOptions = response.map((item) => ({
                    value: item.userId,
                    label: `${item.meta.fullName} (${item.mobile_number})`,
                }));
                setRoleOptions(formattedOptions);
            } else {
                setRoleOptions([]);
            }
        } else {
            setRoleOptions([]);
        }
    };

    const handleIdChange = (e) => {
        const { name, value } = e.target;

        const updatedIds = {
            ...selectedIds,
            [name === "asm"
                ? "asmId"
                : name === "MASTER_DISTRIBUTOR"
                    ? "masterDistributorId"
                    : "distributorId"]: value,
        };

        setSelectedIds(updatedIds);

        roleSelected({
            role: selectedRole,
            selectedIds: updatedIds,
        });
    };

    const handleSkip = async () => {
        setIsSkipped(true);
        const response = await roleapicall(null, `role_type=ASM`);
        if (response) {
            const formattedOptions = response.map((item) => ({
                value: item.userId,
                label: `${item.meta.fullName} (${item.mobile_number})`,
            }));
            setRoleOptions(formattedOptions);
        } else {
            setRoleOptions([]);
        }
    };

    return (
        <div className="w-full bg-white p-4 rounded-lg shadow-2xl mb-4">
            {/* Main Dropdown uses your normal SelectField */}
            <SelectField
                label="Select Role"
                name="role"
                value={selectedRole}
                onChange={handleRoleChange}
                options={roleOption}
                required={true}
                disabled={isDisabled}
                className={`${isDisabled ? "bg-gray-500 text-gray-500 cursor-not-allowed pointer-events-none" : ""}`}
            />

            {/* Sub-Dropdowns use the new SearchableSelect */}
            {selectedRole === "INDEPENDENT_MERCHANT" && roleOptions.length > 0 && (
                <SearchableSelect
                    label="Select ASM"
                    name="asm"
                    value={selectedIds.asmId}
                    onChange={handleIdChange}
                    options={roleOptions}
                    required={true}
                />
            )}

            {selectedRole === "MASTER_DISTRIBUTOR" && roleOptions.length > 0 && (
                <SearchableSelect
                    label="Select ASM"
                    name="asm"
                    value={selectedIds.asmId}
                    onChange={handleIdChange}
                    options={roleOptions}
                    required={true}
                />
            )}

            {selectedRole === "DISTRIBUTOR" && !isSkipped && roleOptions.length > 0 && (
                <>
                    <SearchableSelect
                        label="Select MASTER_DISTRIBUTOR"
                        name="MASTER_DISTRIBUTOR"
                        value={selectedIds.masterDistributorId}
                        onChange={handleIdChange}
                        options={roleOptions}
                        required={true}
                    />
                    <button
                        type="button"
                        className="mt-2 px-4 py-2 bg-gray-300 hover:bg-gray-400 font-medium transition-colors rounded"
                        onClick={handleSkip}
                    >
                        Skip
                    </button>
                </>
            )}

            {selectedRole === "DISTRIBUTOR" && isSkipped && roleOptions.length > 0 && (
                <SearchableSelect
                    label="Select ASM"
                    name="asm"
                    value={selectedIds.asmId}
                    onChange={handleIdChange}
                    options={roleOptions}
                    required={true}
                />
            )}

            {selectedRole === "MERCHANT" && roleOptions.length > 0 && (
                <SearchableSelect
                    label="Select DISTRIBUTOR"
                    name="DISTRIBUTOR"
                    value={selectedIds.distributorId}
                    onChange={handleIdChange}
                    options={roleOptions}
                    required={true}
                />
            )}
        </div>
    );
};

export default NetworkRole;